<template>
  <article :class="`related-section-${page}`">
    <h3
      class="text-color-topaz-light font-museo-500 related-title xs:pl-0 pl-[0.813rem]"
    >
      {{ $t("profiles.titles.relatedEvents") }}
    </h3>
    <div class="slider-gradient"></div>
    <carousel
      :breakpoints="breakpointSwitch"
      :transition="500"
      :wrap-around="false"
      :aria-label="$t('profiles.titles.relatedEvents')"
      class="carousel fixed-carousel-arrows"
      @mousedown="handleMouseDown"
      @mousemove="cancelOpen"
      @mouseup="handleMouseUp"
    >
      <slide
        v-for="(relatedEvent, index) in events"
        :key="relatedEvent.id"
        :aria-hidden="false"
      >
        <event-card
          v-if="relatedEvent"
          :event="relatedEvent"
          type="small"
          :class="{ 'xs:ml-0 ml-[0.813rem]': index === 0 }"
          :is-link="openArtist"
          @empty-ad="pageSwitch($event)"
        />
      </slide>
    </carousel>
  </article>
</template>

<script setup>
import EventCard from "@/components/wegow/ui/cards/EventCard.vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import { useEvent } from "@/composables/useEvent";
import { BREAKPOINTS } from "@/constants.js";
import { computed, ref } from "vue";

const {
  details: event,
  eventsRelatedToEvent,
  deleteAdRelatedToEvent,
  deleteAdRelatedToArtist
} = useEvent();
const props = defineProps({
  eventsRelated: {
    type: Array,
    default: undefined
  },
  breakpoints: {
    type: String,
    default: "middel"
  },
  page: {
    type: String,
    default: "event"
  }
});
const isArtist = ref(false);
const openArtist = ref(true);
const breakpointSwitch = computed(() => {
  switch (props.breakpoints) {
    case "six-cards":
      return BREAKPOINTS.sixCards;
    case "event-cards":
      return BREAKPOINTS.eventCards;
    default:
      return BREAKPOINTS.middleScreenEventCard;
  }
});
const events = computed(() => {
  return props.eventsRelated
    ? props.eventsRelated
    : eventsRelatedToEvent.value.events;
});
const pageSwitch = event => {
  switch (props.breakpoints) {
    case "artist":
      return deleteAdRelatedToArtist(event);
    default:
      return deleteAdRelatedToEvent(event);
  }
};
const handleMouseDown = () => {
  isArtist.value = true;
};
const cancelOpen = () => {
  if (isArtist.value && openArtist.value) {
    openArtist.value = false;
  }
};
const handleMouseUp = () => {
  if (isArtist.value) {
    setTimeout(() => {
      isArtist.value = false;
      openArtist.value = true;
    }, 250);
  }
};
</script>

<style lang="scss" scoped>
@import "@/components/general/ui/profiles/profiles.scss";
</style>
